// Global Instructions Rule Applied! - 2026-05-06
import type { ViewConfigColumn } from '../../../core/components/ViewConfig/types.ts'

const TAG_DISPLAY_KEYS = new Set([
  'contact_prospects__lead',
  'contact_accounts__introduced_by',
  'contact_accounts__sourced_by'
])

/** `cfg.reporting_columns` does not carry `tag_display`; align with legacy fundraising table behaviour. */
export function augmentFundraisingViewConfigColumns(columns: ViewConfigColumn[]): ViewConfigColumn[] {
  return columns.map((c) =>
    TAG_DISPLAY_KEYS.has(c.valueKey) ? { ...c, tagDisplay: true } : c
  )
}
